module.exports = __webpack_public_path__ + "static/media/Snover_gaussian2.f8c962bc.png";